import {createLogger, format} from "winston";
import Transport from "winston-transport";

// Browser-compatible transport that extends winston-transport properly
class BrowserTransport extends Transport {
    constructor(opts: any = {}) {
        super(opts);
    }

    log(info: any, callback: () => void) {
        const timestamp = info?.timestamp || '';
        const level = info?.level || 'info';
        const label = info?.label || 'client';
        const message = info?.message || '';
        const formatted = `[${timestamp}] [${level}] [${label}] ${message}`;

        if (level === 'error') {
            console.error(formatted);
        } else if (level === 'warn') {
            console.warn(formatted);
        } else {
            console.log(formatted);
        }

        callback();
    }
}

export let logPrintFormat = format.printf(({level, message, label, timestamp}) => {
    return `[${timestamp}] [${level}] [${label}] ${message}`;
});

export let logFormat = format.combine(
    format.timestamp({
        format: ':mm:ss.SSS'
    }),
    format.errors({stack: true}),
    format.colorize(),
    logPrintFormat
);

export const consoleTransport = new BrowserTransport({
    level: 'info',
    format: logFormat,
});

export const clientDebugTransport = new BrowserTransport({
    level: 'debug',
    format: logFormat,
});

export const mainLogger = createLogger({
    transports: [consoleTransport],
}).child({label: 'main'})
